import React from 'react'

import ChatClinicsProvider from '~components/chats/clinics-provider'
import ChatsProvider from '~components/chats/chats-provider'
import { useClinic } from '~contexts/clinic-context'
import { useOpenChats } from './open-chats-provider'
import ChatPopover from './chat-popover'

/**
 * Renders the stack of open chat popovers. Lives at the root layout level so
 * popovers persist across page navigations. Mounts the heavy chat provider
 * chain (ChatClinicsProvider + ChatsProvider) only when there is at least
 * one open popover, to avoid running chat-list queries on unrelated pages.
 */
export default function ChatPopovers() {
    const { openChatIds } = useOpenChats()
    const { clinic, clinicGroup } = useClinic()

    /**
     * Need at least one chat scope to render -- `ChatClinicsProvider` works
     * with either a selected clinic or a selected clinic group (enterprise
     * view), so we accept both. Without this, enterprise users opening a
     * chat (e.g. from the compliance tracker) would silently get nothing.
     */
    if (!openChatIds.length || (!clinic && !clinicGroup)) return null

    return (
        <ChatClinicsProvider>
            <ChatsProvider>
                {openChatIds.map((chatId, index) => (
                    <ChatPopover
                        key={chatId}
                        chatId={chatId}
                        stackIndex={index}
                    />
                ))}
            </ChatsProvider>
        </ChatClinicsProvider>
    )
}
